export default "/images/stock.png?ee4b7a5175a94bb3565d182398cc02a1";